<template>
    <div class="content-wapper">

        <el-row class="navigation">
            <el-col align="left">
                <el-breadcrumb separator-class="el-icon-arrow-right">
                    <el-breadcrumb-item :to="{ path: '' }">当前位置:</el-breadcrumb-item>
                    <el-breadcrumb-item :to="{ path: '/main/index' }">首页</el-breadcrumb-item>
                    <el-breadcrumb-item :to="{ path: '' }">检验检测服务</el-breadcrumb-item>
                    <el-breadcrumb-item>产品质量检测</el-breadcrumb-item>
                </el-breadcrumb>
            </el-col>
        </el-row>
        <el-row>
            <el-col :span="6">
                <el-row class="left-img">
                    <img src="@/assets/images/jyjcfw/cpzljc/cpzljc.png"/>
                </el-row>
                <el-row class="menu-box" style="height: 340px;">
                    <el-menu default-active="1-1"
                             class="el-menu-vertical-demo"
                             text-color="#000"
                             active-text-color="#ffd04b"
                             @select="handleSelect">
                        <el-submenu index="1">
                            <template slot="title">
                                <i class="el-icon-menu"></i>
                                <span>检验检测服务</span>
                            </template>
                            <el-menu-item index="1-1">
                                <i class="el-icon-document"></i>
                                <span slot="title">业务在线申请</span>
                            </el-menu-item>
                        </el-submenu>
                        <el-menu-item index="2">
                            <i class="el-icon-link"></i>
                            <span>获准资质认定机构查询</span>
                        </el-menu-item>
                        <el-menu-item index="3">
                            <i class="el-icon-link"></i>
                            <span>省内检验检测机构许可查询</span>
                        </el-menu-item>
						<el-menu-item index="4">
						    <i class="el-icon-link"></i>
						    <span>产品质量检验检测收费标准公示</span>
						</el-menu-item>
                    </el-menu>
                </el-row>
            </el-col>
            <el-col :span="18" class="right-box" >
                <div class="form-div">
                    <el-row class="right-box-row" style="height: auto;">

                        <el-row class="right-box-row-title">
                            检验检测服务业务在线申请
                        </el-row>

                        <el-form ref="form" :model="form" :rules="rules" label-width="130px" label-position="right">
                            <el-row>
                                <el-col :span="10">
                                    <el-form-item label="任务编号" prop="taskId">
                                        <el-input v-model="form.taskId" placeholder="请输入任务编号" size="small" disabled/>
                                    </el-form-item>
                                </el-col>
                                <el-col :span="10">
                                    <el-form-item label="样品名称" prop="ypName">
                                        <el-input v-model="form.sampleName" placeholder="请输入样品名称" size="small" maxlength="50"/>
                                    </el-form-item>
                                </el-col>
                            </el-row>
                            <el-row>
                                <el-col :span="10">
                                    <el-form-item label="样品等级" prop="ypGrade">
                                        <el-input v-model="form.sampleLevel" placeholder="请输入样品等级" size="small" maxlength="50"/>
                                    </el-form-item>
                                </el-col>
                                <el-col :span="10">
                                    <el-form-item label="规格型号" prop="speModel">
                                        <el-input v-model="form.speModel" placeholder="请输入规格型号" size="small" maxlength="50"/>
                                    </el-form-item>
                                </el-col>
                            </el-row>
                            <el-row>
                                <el-col :span="10">
                                    <el-form-item label="注册商标" prop="registTrademark">
                                        <el-input v-model="form.registTrademark" placeholder="请输入注册商标" size="small" maxlength="50" />
                                    </el-form-item>
                                </el-col>
                                <el-col :span="10">
                                    <el-form-item label="检验类别">
                                        <el-select v-model="form.checkType" placeholder="请选择检验类别" size="small" style="width: 250px" filterable allow-create default-first-option>
                                            <el-option
                                                    v-for="item in checkTypes"
                                                    :key="item.dictValue"
                                                    :label="item.dictLabel"
                                                    :value="item.dictValue">
                                            </el-option>
                                        </el-select>
                                    </el-form-item>
                                </el-col>
                            </el-row>
                            <el-row>
                                <el-col :span="10">
                                    <el-form-item label="委托单位" prop="entrustDept">
                                        <el-input v-model="form.entrustDept" placeholder="请输入委托单位" size="small"  maxlength="120"/>
                                    </el-form-item>
                                </el-col>
                                <el-col :span="10">
                                    <el-form-item label="委托单位地址" prop="entrustdeptDom">
                                        <el-input v-model="form.entrustdeptDom" placeholder="请输入委托单位地址" size="small" maxlength="120"/>
                                    </el-form-item>
                                </el-col>
                            </el-row>
                            <el-row>
                                <el-col :span="10">
                                    <el-form-item label="委托单位电话" prop="entrustdeptTel">
                                        <el-input v-model="form.entrustdeptTel" placeholder="请输入委托单位电话" size="small" maxlength="30"/>
                                    </el-form-item>
                                </el-col>
                                <el-col :span="10">
                                    <el-form-item label="委托单位联系人" prop="entrustdeptLxr">
                                        <el-input v-model="form.entrustdeptLxr" placeholder="请输入委托单位联系人" size="small" maxlength="30" />
                                    </el-form-item>
                                </el-col>
                            </el-row>
                            <el-row>
                                <el-col :span="10">
                                    <el-form-item label="生产单位" prop="productionDept">
                                        <el-input v-model="form.productionDept" placeholder="请输入生产单位" size="small" maxlength="120"/>
                                    </el-form-item>
                                </el-col>
                                <el-col :span="10">
                                    <el-form-item label="生产单位地址" prop="productiondeptDom">
                                        <el-input v-model="form.productiondeptDom" placeholder="请输入生产单位地址" size="small" maxlength="120"/>
                                    </el-form-item>
                                </el-col>
                            </el-row>
                            <el-row>
                                <el-col :span="10">
                                    <el-form-item label="生产单位电话" prop="productiondeptTel">
                                        <el-input v-model="form.productiondeptTel" placeholder="请输入生产单位电话" size="small" maxlength="30"/>
                                    </el-form-item>
                                </el-col>
                                <el-col :span="10">
                                    <el-form-item label="生产单位联系人" prop="productiondeptLxr">
                                        <el-input v-model="form.productiondeptLxr" placeholder="请输入生产单位联系人" size="small" maxlength="30"/>
                                    </el-form-item>
                                </el-col>
                            </el-row>
                            <el-row>
                                <el-col :span="10">
                                    <el-form-item label="生产日期" prop="productionTime">
                                        <el-date-picker clearable size="small" style="width: 250px"
                                                        v-model="form.productionTime"
                                                        type="date"
                                                        value-format="yyyy-MM-dd"
                                                        placeholder="选择生产日期">
                                        </el-date-picker>
                                    </el-form-item>
                                </el-col>
                                <el-col :span="10">
                                    <el-form-item label="生产批号" prop="productionBatnum">
                                        <el-input v-model="form.productionBatnum" placeholder="请输入生产批号" size="small" maxlength="50"/>
                                    </el-form-item>
                                </el-col>
                            </el-row>
                            <el-row>
                                <el-col :span="10">
                                    <el-form-item label="样品数量" prop="sampleNum">
                                        <el-input v-model="form.sampleNum" placeholder="请输入样品数量" size="small" />
                                    </el-form-item>
                                </el-col>
                                <el-col :span="10">
                                    <el-form-item label="委托日期" prop="entrustDate">
                                        <el-date-picker clearable size="small" style="width: 250px"
                                                        v-model="form.entrustDate"
                                                        type="date"
                                                        value-format="yyyy-MM-dd"
                                                        placeholder="选择委托日期">
                                        </el-date-picker>
                                    </el-form-item>
                                </el-col>
                            </el-row>
                            <el-row>
                                <el-col :span="10">
                                    <el-form-item label="样品保存条件" prop="sampleKeep">
                                        <el-select v-model="form.sampleKeep" placeholder="请选择样品保存条件" size="small" style="width: 250px" filterable allow-create default-first-option>
                                            <el-option
                                                    v-for="item in sampleKeeps"
                                                    :key="item.dictValue"
                                                    :label="item.dictLabel"
                                                    :value="item.dictValue">
                                            </el-option>
                                        </el-select>
                                    </el-form-item>
                                </el-col>
                                <el-col :span="10">
                                    <el-form-item label="样品处理" prop="sampleHandle">
                                        <el-select v-model="form.sampleHandle" placeholder="请选择样品处理" style="width: 250px" size="small" filterable allow-create default-first-option>
                                            <el-option
                                                    v-for="item in sampleHandles"
                                                    :key="item.dictValue"
                                                    :label="item.dictLabel"
                                                    :value="item.dictValue">
                                            </el-option>
                                        </el-select>
                                    </el-form-item>
                                </el-col>
                            </el-row>
                            <el-row>
                                <el-col :span="10">
                                    <el-form-item label="报告份数" prop="reportNum">
                                        <el-select v-model="form.reportNum" placeholder="请选择样品处理" style="width: 250px" size="small">
                                            <el-option
                                                    v-for="item in reportNums"
                                                    :key="item.dictValue"
                                                    :label="item.dictLabel"
                                                    :value="item.dictValue">
                                            </el-option>
                                        </el-select>
                                    </el-form-item>
                                </el-col>
                                <el-col :span="10">
                                    <el-form-item label="检验标准日期" prop="testDate">
                                        <el-date-picker clearable size="small" style="width: 250px"
                                                        v-model="form.testStandard"
                                                        type="date"
                                                        value-format="yyyy-MM-dd"
                                                        placeholder="选择检验标准日期">
                                        </el-date-picker>
                                    </el-form-item>
                                </el-col>
                            </el-row>
                            <el-row>
                                <el-col :span="20">
                                    <el-form-item label="检验项目" prop="testProject">
                                        <el-input type="textarea" v-model="form.testProject" placeholder="请输入检验项目"
                                                  :autosize="{ minRows: 4, maxRows: 6}"/>
                                    </el-form-item>
                                </el-col>
                            </el-row>
                            <el-form-item>
                                <el-checkbox v-model="promise">我承诺：我所填写的发布内容及附件真实有效。我单位对填写的内容真实性负责，如有虚假将依法承担相应责任。</el-checkbox>
                            </el-form-item>
                            <el-row>
                                <el-col :span="24"  class="btn">
                                    <el-button type="info" @click="submitForm('N')">保 存</el-button>
                                    <el-button type="primary" @click="submitForm('Y')">提交并申报</el-button>
                                </el-col>
                            </el-row>
                            <el-row>
                                <el-col :span="24" style="margin-top: 1.875rem;margin-left:1.875rem;text-align: left;color: #959595;">
                                    <span >注：保存后的信息可以再次编辑，提交并申报后的信息不可更改，提交申报后需等待审核。</span>
                                </el-col>
                            </el-row>
                        </el-form>
                    </el-row>
                </div>

            </el-col>
        </el-row>
    </div>
</template>


<script>
    import { addYwzxsq, updateYwzxsq, getYwzxsq, downloadPdfCpzljc } from "@/api/jyjcfw/ywzxsq";
    import {updatePvNum} from "@/api/itempv/pv";
    export default {
        name: "cpzljc",
        data() {
            return {
                // 遮罩层
                loading: false,
                // 总条数
                total: 0,
                list:[],
                queryParams:{
                    pageNum:1,
                    pageSize:10
                },
                promise:false,
                // 表单参数
                form: {
                    pageNum: 1,
                    pageSize: 10,
                    taskId: undefined,
                    sampleName: undefined,
                    sampleLevel: undefined,
                    speModel: undefined,
                    registTrademark: undefined,
                    sampleIdentification: undefined,
                    sampleState: undefined,
                    checkType: undefined,
                    entrustDept: undefined,
                    entrustdeptDom: undefined,
                    entrustdeptTel: undefined,
                    entrustdeptLxr: undefined,
                    productionDept: undefined,
                    productiondeptDom: undefined,
                    productiondeptTel: undefined,
                    productiondeptLxr: undefined,
                    productionTime: undefined,
                    productionBatnum: undefined,
                    sampleNum: undefined,
                    entrustDate: undefined,
                    sampleKeep: undefined,
                    sampleHandle: undefined,
                    reportNum: undefined,
                    testStandard: undefined,
                    testProject: undefined,
                    shType: undefined,
                    deleteStatus: undefined,
                    queryTimestamp: undefined,
                    isTemstorage: undefined,
                    ywFwjgRecid:undefined,
					ywSaveStatus:undefined,
                },
                // 表单校验
                rules: {
                    taskId:[
                        { required: true, message: '请输入任务编号', trigger: 'change' }
                    ],
                    sampleName:[
                        { required: true, message: '请输入样品名称', trigger: 'change' }
                    ],
                    sampleIdentification:[
                        { required: true, message: '请选择样品标识', trigger: 'change' }
                    ],
                    sampleState:[
                        { required: true, message: '请选择样品状态', trigger: 'change' }
                    ],
                    checkType:[
                        { required: true, message: '请选择检验类别', trigger: 'change' }
                    ],
                    entrustDept:[
                        { required: true, message: '请输入委托单位名称', trigger: 'change' }
                    ],
                    entrustdeptDom:[
                        { required: true, message: '请输入委托单位地址', trigger: 'change' }
                    ],
                    entrustdeptTel:[
                        { required: true, message: '请输入委托单位电话', trigger: 'change' }
                    ],
                    entrustdeptLxr:[
                        { required: true, message: '请输入委托单位联系人', trigger: 'change' }
                    ],
                    productionTime:[
                        { required: true, message: '请选择生产日期', trigger: 'change' }
                    ],
                    entrustDate:[
                        { required: true, message: '请选择委托日期', trigger: 'change' }
                    ],
                    testStandard:[
                        { required: true, message: '请选择检验标准', trigger: 'change' }
                    ],
                    testProject:[
                        { required: true, message: '请输入检验项目', trigger: 'change' }
                    ],
                },
                sampleIdentifications: [],
                sampleStates: [],
                checkTypes: [],
                sampleKeeps: [],
                sampleHandles: [],
                reportNums: [],
                recid: undefined,
				uuid:undefined
            }
        },
        created() {
            this.form.taskId = this.getCode(32);
            this.getDicts("ywzxsq_checkTypes").then(response => {
                this.checkTypes = response.data;
            });
            this.getDicts("ywzxsq_reportNums").then(response => {
                this.reportNums = response.data;
            });
            this.getDicts("ywzxsq_sampleHandles").then(response => {
                this.sampleHandles = response.data;
            });
            this.getDicts("ywzxsq_sampleKeeps").then(response => {
                this.sampleKeeps = response.data;
            });
            this.recid = this.$route.params && this.$route.params.recid;
            // console.log(this.recid)
            this.getDetail();
			
        },
        methods: {
            getDetail(){
                if (this.recid != null && this.recid != undefined) {
                    this.reset();
                    const recid = this.recid;
                    getYwzxsq(recid).then(response => {
                        // console.log(response)
                        this.form = response.data;
                    });
                }
            },
            // 表单重置
            reset() {
                this.form = {
                    taskId: undefined,
                    sampleName: undefined,
                    sampleLevel: undefined,
                    speModel: undefined,
                    registTrademark: undefined,
                    sampleIdentification: undefined,
                    sampleState: undefined,
                    checkType: undefined,
                    entrustDept: undefined,
                    entrustdeptDom: undefined,
                    entrustdeptTel: undefined,
                    entrustdeptLxr: undefined,
                    productionDept: undefined,
                    productiondeptDom: undefined,
                    productiondeptTel: undefined,
                    productiondeptLxr: undefined,
                    productionTime: undefined,
                    productionBatnum: undefined,
                    sampleNum: undefined,
                    entrustDate: undefined,
                    sampleKeep: undefined,
                    sampleHandle: undefined,
                    reportNum: undefined,
                    testStandard: undefined,
                    testProject: undefined,
                    shType: undefined,
                    deleteStatus: undefined,
                    queryTimestamp: undefined,
                    isTemstorage: undefined,
                    ywFwjgRecid:undefined,
                };
                this.resetForm("form");
            },
            toPage(url){
                this.$router.push({
                    path: url,
                });
                this.$store.commit('SET_MAININDEX', url);
            },
            handleSelect(key, keyPath) {
                if(key=='2'){
                    updatePvNum("zlts_cpzljyjc_jyjccxfw").then(response => {
                        //pv 点击检验检测查询服务
                    });
                    window.open('http://cma.cnca.cn/cma/infoQuery/tBzQualificationQuery/tBzQualificationQueryList');
                }else if(key=='3'){
                    updatePvNum("zlts_cpzljyjc_snjyjcjgxknlcxfw").then(response => {
                        //pv 点击省内检验检测机构许可能力查询服务
                    });
                    window.open('http://218.57.139.17:9900/JYJCWEB/webLabYouxiaoListAction!getList.do?qccx=true&org=0');
                }else if(key=='4'){
					downloadPdfCpzljc().then(res => {
						//下载代码
						var blob = new Blob([res], {
						  type: "application/octet-stream;chartset=UTF-8"
						});
						var url = window.URL.createObjectURL(blob);
						var a = document.createElement("a");
						a.href = url;
						a.download = "产品质量检验检测收费标准.pdf";
						a.click();
					});
				}
            },
            submitForm(status){
				updatePvNum("zlts_cpzljyjc_fb").then(response => {
				    //pv 点击产品质量检验检测发布
				});
				if (this.utils.isLoginTimeout()) {
					this.form.ywFwjgRecid=JSON.parse(localStorage.getItem('ssessionLoginUser')).user.ywFwjgRecid;
					this.form.ywSaveStatus = status;
					this.$refs["form"].validate(valid => {
					    if (valid) {
					        if (this.promise) {
					            this.$confirm(`是否${status =='Y' ?"提交" :"保存"}?`, '提示', {
					                confirmButtonText: '确定',
					                cancelButtonText: '取消',
					                type: 'warning'
					            }).then(() => {
					                this.saveForm();
					            })
					        } else {
					            this.msgWarning("请选择承诺");
					        }
					    }
					})
				} else {
					this.$confirm('登录已过期，您可以继续留在该页面，或者重新登录?', '提示', {
					    confirmButtonText: '确定',
					    cancelButtonText: '取消',
					    type: 'warning'
					}).then(() => {
					    this.logout()
					})
				}
            },
            saveForm(){
                if (this.form.recid != undefined) {
                    updateYwzxsq(this.form).then(response => {
                        if (response.code === 200) {
                            this.msgSuccess("修改成功");
							this.reset();
                            this.$router.back();
                        } else {
                            this.msgError(response.msg);
                        }
                    });
                } else {
                    addYwzxsq(this.form).then(response => {
                        if (response.code === 200) {
                            this.msgSuccess("成功");
                            this.$router.back();
                        } else {
                            this.msgError(response.msg);
                        }
                    });
                }
            },
            // 生成随机字符串
            getCode(codeLength){
                let UPPER = "ABCDEFGHIJKLMNOPQRSTUVWXYZ";
                let LOWER = UPPER.toLocaleLowerCase();
                let DIGITS = "0123456789";
                let ALPHA_NUMBER = UPPER + LOWER + DIGITS;
                let MIN_STRING_LENGTH = 1;
                let MIN_SYMBOLS_LENGTH = 2;
                //字符串转成数组
                let symbols=new Array()
                for(let i= 0; i< ALPHA_NUMBER.length;i++){
                    symbols[i] = ALPHA_NUMBER.charAt(i)
                }
                //随机拼接字符串
                let stateCode = "";
                for(let i= 0;i<codeLength;i++){
                    stateCode += symbols[Math.floor((Math.random() * symbols.length))];
                }
                return stateCode;
            },
        }
    }
</script>

<style scoped>
    .content-wapper{
        margin-top: 5px;
        padding: 10px;
    }
    .navigation{
        padding:20px 15px;
        line-height: 20px;
        height: 60px;
        background-color: #F5F5F5;
        margin-bottom: 15px;
    }
    .left-img img{
        width: 100%;
    }
    .menu-box{
        background-color: #FAFAFA;
        padding: 15px 10px;
    }
    /deep/.el-menu{
        text-align: left;
        background-color:#FAFAFA;
        border:0;
    }
    .menu-box /deep/.el-menu-item.is-active{
        background-color:#EAEAEA;
    }
    .right-box{
        padding-left: 10px;
    }
    .right-box-row{
        border: 1px solid #cccccc;
        padding: 10px 15px;
    }
    .right-box-row-tip{
        padding: 10px;
        background-color: #FBF8E5;
    }

    .right-box-row-title{
        padding: 15px 0;
        text-align: left;
        color: #1c84c6;
        font-size: 18px;
        font-weight: bold;
        border-bottom: 1px solid #cccccc;
        margin-bottom: 20px;
    }


</style>